import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Error from '../common/Message/error';
import Success from "../common/Message/success";
import Sidebar from "../common/Sidebar";
import Spinner from "../common/Spinner/spinner";
import ContactList from '../Contacts/contactList';
import "./addLocation.css";
import Contacts from './contacts';
import { getEMREHRList, getTimeZoneDropdownList, getTravelDistanceList } from './endpoints/action';
import { addLocationSelector } from "./endpoints/selector";
import { setAction, setInitalState } from './endpoints/slice';
import LocationForm from "./form";


// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const navigate = useNavigate();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');

    const { timezoneDropdownList, travelDistanceList, emrehrList,
        successMessage, errorMessage, action, addToContact, setLocationName ,loadingFlag} = useSelector(addLocationSelector);
    const [timeZonesDropdownList, setTimeZoneDropdownList] = useState([]);
    const [travelDistancesList, setTravelDistancesList] = useState([]);
    const [emrehrsList, setEmrEhrList] = useState([]);
    const [showContacts, setShowContacts] = useState(false);
    const [hideContacts, sethideContacts] = useState(false);
    const location = useLocation();
    const { contacts, contactList, name, locationDetails, hideContact, isMapActive } = location.state;
    const [isAction, setAction] = useState('add');
    const [locationsDetails, setLocationsDetails] = useState(locationDetails);
    const [contactsList, setContactsList] = useState([]);
    const [locationName, setLocationsName] = useState(name);
    const [success, setSuccess] = useState('');
    const [addContact, setAddContact] = useState('');
    const dispatch = useDispatch();
    const fromAddLocation = true;
    // console.log('-------------', locationDetails);

    useEffect(() => {
        document.title = "Employers Section";
        dispatch(setInitalState());
    }, []);

    useEffect(() => {
        if (config.baseUrl) {
            dispatch(getTimeZoneDropdownList(config.baseUrl));
            dispatch(getTravelDistanceList(config.baseUrl));
            dispatch(getEMREHRList(config.baseUrl, login?.employerId));
            dispatch(setInitalState());
        }
    }, [config]);

    useEffect(() => {
        if (locationName !== '' && locationName !== undefined) {
            setAction('edit')
        } else {
            setAction('add');
        }
    }, [locationName !== undefined]);

    useEffect(() => {
        if (contacts === "true") {
            setShowContacts(true)
        } else {
            setShowContacts(false)
        }
    }, [contacts]);

    useEffect(() => {
        if (hideContact === true) {
            sethideContacts(true)
        } else {
            sethideContacts(false)
        }
    }, [hideContact]);

    useEffect(() => {
        if (travelDistanceList.length > 0) {
            setTravelDistancesList(travelDistanceList);
        }
    }, [travelDistanceList]);

    useEffect(() => {
        setLocationsDetails(locationDetails);
        dispatch(setInitalState());
    }, [locationDetails]);

    useEffect(() => {
        if (contactList !== undefined) {
            setContactsList(contactList);
            dispatch(setInitalState());
        }
    }, [contactList]);

    useEffect(() => {
        setLocationsName(name);
    }, [name]);

    useEffect(() => {
        if (timezoneDropdownList.length > 0) {
            setTimeZoneDropdownList(timezoneDropdownList);
        }
    }, [timezoneDropdownList]);

    useEffect(() => {
        if (successMessage) {
            setSuccess(successMessage);
        }
    }, [successMessage]);

    useEffect(() => {
        setAddContact(addToContact);
    }, [addToContact]);

    useEffect(() => {
        if (emrehrList.length > 0) {
            setEmrEhrList(emrehrList);
        }
    }, [emrehrList]);

    /* useEffect(() => {
        if(success !== null) {
            if(action === 'save') {
                sethideContacts(false)
            } else if(action === 'add') {
                navigate("/adduser", 
                {
                    state: {
                        addContacts: true
                    }
                })
            }
                
        }  else {
            navigate('/addlocations', {
                state: {
                    contacts: "false",
                    hideContact: true,
                    isMapActive: false
                }
            });
        } 
            
    }, [success !== null]); */

    useEffect(() => {
        if (addContact) {
            if (action === 'add') {
                navigate("/adduser",
                    {
                        state: {
                            addContacts: true,
                            locationName: setLocationName
                        }
                    })
            }
        } else {
            if (action === 'save') {
                sethideContacts(false)
            }
        }

        /* else {
           navigate('/addlocations', {
               state: {
                   contacts: "false",
                   hideContact: true,
                   isMapActive: false
               }
           });
       } */

    }, [addContact]);

    useEffect(() => {
        if (action === 'save') {
            sethideContacts(false)
        }
    }, [action]);

    const addNewContact = () => {
        navigate("/adduser",
            {
                state: {
                    addContacts: true
                }
            })
    }

    const valueDD = 1467;
    return (
        <div className="page main-margin">
            {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}

            <Header />
            <Sidebar />
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">

                                <h1 className="page-title">Add Locations</h1>

                                {/* <div>
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                                        <li class="breadcrumb-item active" aria-current="page">Add Location</li>
                                    </ol>
                                </div> */}
                            </div>
                            {/* <div class="locationName-margin">
                                <span class="locationName">{locationName ? locationName : 'Add New'}</span>
                            </div> */}
                            {/* <div className="row">
                                <div class="col-xl-12">
                                    <div class="card">
                                        <div class="card-body"> */}
                                            {
                                                errorMessage && <Error errorMessage={errorMessage} />
                                            }
                                            {
                                                successMessage && <Success successMessage={successMessage} />
                                            }
                                            <div class="panel panel-primary">
                                                <div class="tab-menu-heading tab-menu-heading-boxed">
                                                    <div class="tabs-menu-boxed">
                                                        
                                                        {showContacts &&
                                                        <ul class="nav panel-tabs panel-secondary">
                                                            <li><a href="#tab25" className={!showContacts ? 'active' : ''} data-bs-toggle="tab" onClick={() => setShowContacts(false)} >Details</a></li>
                                                            {!hideContacts && <li><a href="#tab26" className={showContacts ? 'active' : ''} data-bs-toggle="tab" onClick={() => setShowContacts(true)} >Contacts</a></li>}
                                                        </ul>
                                                        }

                                                        {showContacts && <div class="newLocation">
                                                            <button class="btn btn-success" onClick={addNewContact}>Add New Contact</button>
                                                        </div>}

                                                    </div>
                                                </div>
                                                {!showContacts && <LocationForm locationDetails={locationsDetails} showContacts={showContacts} addNewContact={addNewContact} setShowContacts={setShowContacts} hideContacts={hideContacts}
                                                    travelDistancesList={travelDistancesList} emrehrsList={emrehrsList} timeZonesDropdownList={timeZonesDropdownList} isAction={isAction} isMapActive={isMapActive} />}
                                                {/* {showContacts && <Contacts contactList={contactList} />} */}
                                                {showContacts && <ContactList contactList={contactsList} fromAddLocation={fromAddLocation} locationId={locationDetails?.locationId} />}
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                        
            // //         </div>
            // //     </div>
            // // </div>

        // </div>
    )
}